import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import SideBar from './components/admin/layout/SideBar';
import Header from './components/admin/layout/Header';
import Footer from './components/admin/layout/Footer';

import AppRoutes from './routes/Admin';
import WebsiteRoutes from './routes/Web';

import Navbar from "./components/web/Navbar";
import FooterWeb from "./components/web/Footer";

import Login from './pages/admin/login/Login';
import AdminRoute from './routes/AdminRoute';

// -------------------- Layouts --------------------
function AdminLayout() {
  return (
    <div className="wrapper">
      <SideBar />
      <div className="main-panel">
        <Header />
        <div className="container">
          <Routes>
            {AppRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
}

function WebsiteLayout() {
  return (
    <div>
      <Navbar />
      <Routes>
        {WebsiteRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
      <FooterWeb />
    </div>
  );
}

// -------------------- Root Render --------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>

      <Routes>

        {/* Website Section */}
        <Route path="/*" element={<WebsiteLayout />} />

        {/* Admin Login (No Protection) */}
        <Route path="/admin/login" element={<Login />} />

        {/* Admin Panel (Protected) */}
        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        />

      </Routes>

    </Router>
  </React.StrictMode>
);
